import { LogLevel, Configuration, RedirectRequest } from '@azure/msal-browser';

/**
 * Production Environment Configuration
 * Azure AD B2C Authentication (for external candidates)
 * Azure AD Corporate Authentication (for Microsoft employees)
 */

// Azure AD B2C Configuration - for external candidates
const b2cTenantName = 'hroffboarding'; // e.g., 'contosob2c'
const b2cTenantId = '332a0960-e037-4f11-bf0f-6a64a4c9b727'; // Your B2C tenant domain
const b2cPolicyName = 'B2C_1_onboarding'; // Your sign-up/sign-in policy name

// Azure AD Corporate Configuration - for Microsoft employees
const aadTenantId = '72f988bf-86f1-41af-91ab-2d7cd011db47'; // Microsoft corporate tenant

export const msalConfig: Configuration = {
  auth: {
    clientId: 'd166910e-a7b9-4c7e-9ae5-85beb6dfd1f3',
    authority: `https://loginnewhirehub.microsoft.com/${b2cTenantId}/${b2cPolicyName}`,
    knownAuthorities: [`${b2cTenantName}.b2clogin.com`, 'loginnewhirehub.microsoft.com'],
    redirectUri: 'https://newhirehub.microsoft.com/auth/b2c', 
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// Azure AD Corporate MSAL Configuration for Microsoft employees
export const msalConfigCorporate: Configuration = {
  auth: {
    clientId: 'f9d80ff5-ac53-4f74-be20-55582788c3eb',
    authority: `https://login.microsoftonline.com/${aadTenantId}`,
    redirectUri: 'https://newhirehub.microsoft.com/auth/corporate',
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// B2C scopes for external candidates
const b2cScopes: string[] = [
  'https://hroffboarding.onmicrosoft.com/d166910e-a7b9-4c7e-9ae5-85beb6dfd1f3/user-impersonation'
];

// Corporate scopes for Microsoft employees
const corporateScopes = [
  'api://f9d80ff5-ac53-4f74-be20-55582788c3eb/default'
];

export const getLoginRequest = (authProvider: 'b2c' | 'corporate'): RedirectRequest => {
  const scopes = authProvider === 'corporate' ? corporateScopes : b2cScopes;
  return { scopes };
};

export const loginRequest: RedirectRequest = {
  scopes: b2cScopes,
};

export const loginRequestCorporate: RedirectRequest = {
  scopes: corporateScopes,
};

// Production-specific settings
export const apiConfig = {
  baseUrl: 'https://newhirehub.microsoft.com', // Update with your production API URL
  timeout: 10000,
};

export const appConfig = {
  enableDebugMode: false,
  enableAnalytics: true,
  logLevel: LogLevel.Warning,
  applicationInsightsConnectionString:
    'InstrumentationKey=8f7245d3-141b-495c-b87c-d41145bc6058;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=1b9a5cb1-2e41-4254-a0cf-994b5db51c23', // TODO: Replace with Production Application Insights connection string
};
